gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

// ScrollTrigger.normalizeScroll(true);

if (
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  )
) {
  //code here
} else {
}

/* var smoother = ScrollSmoother.create({
  smooth: 2,
  effects: true,
  smoothTouch: 0.1,
  normalizeScroll: true,
}); */

/* Counter */
gsap.utils.toArray(".counts").forEach((element) => {
  let clean = (v) => (v + "").replace(/[^\d\.-]/gi, ""), // get rid of anything except numbers and periods
    num = clean(element.getAttribute("data-number")),
    decimals = (num.split(".")[1] || "").length,
    proxy = { val: parseFloat(clean(element.innerText)) || 0 };
  gsap.to(proxy, {
    val: +num,
    duration: 3,
    scrollTrigger: {
      trigger: element,
      toggleActions: "play none none none",
    },
    onUpdate: () => (element.innerText = formatNumber(proxy.val, decimals)),
  });
});

function formatNumber(value, decimals) {
  let s = (+value).toLocaleString("en-US").split(".");
  return decimals
    ? s[0] + "." + ((s[1] || "") + "00000000").substr(0, decimals)
    : s[0];
}
/* Counter */

$(document).ready(function () {

  function onHeaderLoad(){
    $(".ham_menu").on("click", function () {
      $(
        ".header_full_wrp .container_1360_wrp .header_main ul.main_nav",
      ).addClass("open");
    });

    $(".close_ham").on("click", function () {
      $(
        ".header_full_wrp .container_1360_wrp .header_main ul.main_nav",
      ).removeClass("open");
    });
    $(".main_nav .firstLevel").on("click", function () {
      $(
        ".header_full_wrp .container_1360_wrp .header_main ul.main_nav",
      ).removeClass("open");
    });

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      $("body").on(
        "click",
        ".header_full_wrp .container_1360_wrp .header_main ul.main_nav li.drop_level1 a",
        function () {
          $(this).parent().find(".mega_menu").addClass("hover_mob");
        },
      );

      $("body").on(
        "click",
        ".header_full_wrp .container_1360_wrp .header_main ul.main_nav li.drop_level1 .mega_menu .back_btn",
        function () {
          $(this)
            .closest(
              ".header_full_wrp .container_1360_wrp .header_main ul.main_nav li.drop_level1",
            )
            .find(".mega_menu")
            .removeClass("hover_mob");
        },
      );
    } else {
      $(
        ".header_full_wrp .container_1360_wrp .header_main ul.main_nav li.drop_level1",
      ).hoverIntent({
        sensitivity: 3, // number = sensitivity threshold (must be 1 or higher)
        interval: 0, // number = milliseconds for onMouseOver polling interval
        timeout: 0, // number = milliseconds delay before onMouseOut
        over: function () {
          $(this).find(".mega_menu").addClass("hover");
          $(this).siblings().addClass("fadex");
        },
        out: function () {
          $(".mega_menu").removeClass("hover");
          $(this).siblings().removeClass("fadex");
        },
      });
    }

    $(".back_btn").on("click", function () {
      $(this).parent().removeClass("hover");
      $(
        ".header_full_wrp .container_1360_wrp .header_main ul.main_nav li",
      ).removeClass("fadex");
    });

    /* setTimeout(function(){
      stickyNavSetUp();
    }, 1000); */
    scrollToSect();
  }

  function scrollToSect(){
    let navMainLinksArr = $('.header_full_wrp .main_nav li.firstLevel a');
    navMainLinksArr.each(function(){
      $(this).on('click', function(e){
        //e.preventDefault();
        var href = $(this).attr('href');
        console.log($(this));
        navMainLinksArr.removeClass('active');
        $(this).addClass('active');
        $('html, body').animate({ 
            //scrollTop:$(href).offset().top - 20
        },'slow');  
      });
    }); 
  }
  //scrollToSect();
  onHeaderLoad(); 

  // Header
  /* $("#header").load("header.html", function () {
    console.log("header loaded");
    onHeaderLoad(); 
  });
  // Footer
  $("#footer").load("footer.html", function () {
    //console.log("footer loaded");
  }); */

  //smoother.effects("", { speed: "auto" });

  setTimeout(function () {
    stickyNavSetUp();
  }, 100);

  

  // header on scroll effect
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $(".header_full_wrp").outerHeight();

  $(window).scroll(function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $(".header_full_wrp").removeClass("nav-down").addClass("nav-up");
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $(".header_full_wrp").removeClass("nav-up").addClass("nav-down");
      }
    }

    lastScrollTop = st;
  }

  // header on scroll effect

  /* Counter */

  // new SplitText('.lines', {
  //   type: 'lines',
  //   linesClass: 'lineChild2',
  // });
  // new SplitText('.lines', {
  //   type: 'lines',
  //   linesClass: 'lineParent2',
  // });

  // gsap.set('.lineChild', { y: 80, opacity: 0 });
  // gsap.set('.lineChild2', { y: 80, opacity: 0 });
  // gsap.set('.anims', { y: 50, opacity: 0 });

  /* image Reveal */
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.2,
  };

  let revealCallback = (entries, self) => {
    entries.forEach((entry) => {
      let container = entry.target;
      let img = entry.target.querySelector("img");
      const easeInOut = "power3.out";
      const revealAnim = gsap.timeline({ ease: easeInOut });

      if (entry.isIntersecting) {
        revealAnim.set(container, {
          visibility: "visible",
        });
        revealAnim.fromTo(
          container,
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            webkitClipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            webkitClipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            duration: 1,
            ease: easeInOut,
          },
        );
        revealAnim.from(img, 4, {
          scale: 1.4,
          ease: easeInOut,
          delay: -1,
          //markers: true,
        });
        self.unobserve(entry.target);
      }
    });
  };

  let revealObserver = new IntersectionObserver(revealCallback, options);

  document.querySelectorAll(".reveal").forEach((reveal) => {
    revealObserver.observe(reveal);
  });

  if ($(".inner-banner-slider").length > 0) {
    // Initialize Swiper
    const slideCount = document.querySelectorAll(
      ".inner-banner-slider .swiper-slide",
    ).length;
    var InnerBannerSwiper = new Swiper(".inner-banner-slider", {
      slidesPerView: "auto",
      centeredSlides: true,
      speed: 1200,
      grabCursor: true,
      mousewheel: false,
      slidesPerGroup: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: slideCount > 1,
      navigation: {
        nextEl: ".inner-banner-slider .swiper-button-next",
        prevEl: ".inner-banner-slider .swiper-button-prev",
      },
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".inner-banner-slider .swiper-pagination",
        clickable: "true",
        // type: 'bullets',
        // renderBullet: function (index, className) {
        //   return (
        //     '<span class="' + className + '">' + '<i></i>' + '<b></b>' + '</span>'
        //   );
        // },
      },
      on: {
        slideChangeTransitionStart: function () {
          // Slide captions
          var swiper = this;
          setTimeout(function () {
            var currentTitle = $(swiper.slides[swiper.activeIndex]).attr(
              "data-title",
            );
            var currentSubtitle = $(swiper.slides[swiper.activeIndex]).attr(
              "data-subtitle",
            );
          });
          gsap.to($(".inner-banner-slider .current-title"), 0.4, {
            autoAlpha: 0,
            y: -40,
            ease: Power1.easeIn,
          });
          gsap.to($(".inner-banner-slider .current-subtitle"), 0.4, {
            autoAlpha: 0,
            y: -40,
            delay: 0.05,
            ease: Power1.easeIn,
          });
        },
        slideChangeTransitionEnd: function () {
          // Slide captions
          var swiper = this;
          var currentTitle = $(swiper.slides[swiper.activeIndex]).attr(
            "data-title",
          );
          var currentSubtitle = $(swiper.slides[swiper.activeIndex]).attr(
            "data-subtitle",
          );
          $(".inner-banner-slider .slide-captions").html(function () {
            return (
              "<span class='current-title'>" +
              currentTitle +
              "</span>" +
              "<h1 class='current-subtitle'>" +
              currentSubtitle +
              "</h1>" +
              "</div>"
            );
          });
          gsap.from($(".inner-banner-slider .current-title"), 0.4, {
            autoAlpha: 0,
            y: 40,
            ease: Power1.easeOut,
          });
          gsap.from($(".inner-banner-slider .current-subtitle"), 0.4, {
            autoAlpha: 0,
            y: 40,
            delay: 0.15,
            ease: Power1.easeOut,
          });
        },
      },
    });

    var currentTitle = $(
      InnerBannerSwiper.slides[InnerBannerSwiper.activeIndex],
    ).attr("data-title");
    var currentSubtitle = $(
      InnerBannerSwiper.slides[InnerBannerSwiper.activeIndex],
    ).attr("data-subtitle");

    $(".inner-banner-slider .slide-captions").html(function () {
      return (
        "<span class='current-title'>" +
        currentTitle +
        "</span>" +
        "<h1 class='current-subtitle'>" +
        currentSubtitle +
        "</h1>" +
        "</div>"
      );
    });
    gsap.set(
      ".inner-banner-slider .slide-captions .current-title, .inner-banner-slider .slide-captions .current-subtitle, .inner-banner-slider .slide-captions .commonCTA",
      {
        opacity: 0,
        y: 40,
      },
    );
    gsap.to(
      ".inner-banner-slider .slide-captions .current-title, .inner-banner-slider .slide-captions .current-subtitle, .inner-banner-slider .slide-captions .commonCTA",
      {
        opacity: 1,
        y: 0,
        ease: Power1.easeOut,
        duration: 1,
        stagger: {
          each: 0.15,
        },
      },
    );

    if (window.innerWidth > 1200) {
      setTimeout(function () {
        const slides = document.querySelectorAll(
          ".inner-banner-slider .swiper-slide",
        );

        slides.forEach((slide, index) => {
          slide.classList.add(`effect`);
        });
        InnerBannerSwiper.update();
      }, 1000);
    }

    if (window.innerWidth <= 1199) {
    } else {
      // Home Overview Animation
    }
  }

  if ($(".expando").length > 0) {
    function toggleFixedElementVisibility(visible) {
      const fixedElement = document.querySelector(".infoSlide");
      if (visible) {
        // fixedElement.style.display = 'block'; // Show the fixed element
        smoother.paused(true); // Pause ScrollSmoother
        document.body.style.overflow = "hidden"; // Disable body scroll as a backup
      } else {
        // fixedElement.style.display = 'none'; // Hide the fixed element
        smoother.paused(false); // Resume ScrollSmoother
        document.body.style.overflow = ""; // Restore body scroll
      }
    }
    const expandos = document.querySelectorAll(".expando");
    const closeInfoSlides = document.querySelectorAll(".closeInfoSlide");
    const infoSlides = document.querySelectorAll(".infoSlide");
    const overLay = document.querySelectorAll(".overlay");
    expandos.forEach((expando) => {
      expando.addEventListener("click", () => {
        const id = expando.getAttribute("data-id");
        console.log(id);
        const overlay = document.querySelector(".overlay");
        overlay.classList.add("show");
        const infoSlide = document.querySelector(`#${id}`);
        infoSlide.classList.add("open");
        toggleFixedElementVisibility(true);
      });
    });
    closeInfoSlides.forEach((closeInfoSlide) => {
      closeInfoSlide.addEventListener("click", () => {
        const overlay = document.querySelector(".overlay");
        overlay.classList.remove("show");
        infoSlides.forEach((infoSlide) => {
          infoSlide.classList.remove("open");
        });
        toggleFixedElementVisibility(false);
      });
    });
    overLay.forEach((overLay) => {
      overLay.addEventListener("click", () => {
        const overlay = document.querySelector(".overlay");
        overlay.classList.remove("show");
        infoSlides.forEach((infoSlide) => {
          infoSlide.classList.remove("open");
        });
        toggleFixedElementVisibility(false);
      });
    });
  }

  $(".readmoreBt a").click(function () {
    var moreText = $(this).closest(".readmoreBt").prev(".more-text");
    var icon = $(this).find("span");

    if (moreText.height() === 0) {
      // Expand
      moreText.animate(
        {
          height: moreText.get(0).scrollHeight,
        },
        500,
      );
      icon.text("−"); // Change to minus
    } else {
      // Collapse
      moreText.animate(
        {
          height: 0,
        },
        500,
      );
      icon.text("+"); // Change to plus
    }
  });

  if ($(".visionSwiper").length > 0) {
    var visionSwiper = new Swiper(".visionSwiper", {
      navigation: {
        nextEl: ".vision-next",
        prevEl: ".vision-prev",
      },
      allowTouchMove: false,
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  }

  // if ($(".awardsSwiper").length > 0) {
  //   var awardsSwiper = new Swiper(".awardsSwiper", {
  //     // slidesPerView: 1,
  //     // spaceBetween: 10,
  //     loop: false,
  //     navigation: {
  //       nextEl: ".award-next",
  //       prevEl: ".award-prev",
  //     },
  //     breakpoints: {
  //       300: {
  //         slidesPerView: 2.2,
  //         spaceBetween: 20,
  //       },
  //       768: {
  //         slidesPerView: 2,
  //         spaceBetween: 20,
  //       },
  //       1024: {
  //         slidesPerView: 3,
  //         spaceBetween: 30,
  //       },
  //     },
  //   });
  // }

  if ($(".focusSwiper").length > 0) {
    var focusSwiper = new Swiper(".focusSwiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      allowTouchMove: false,
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  }

  /* if ($(".home_career_wrp").length > 0) {
    if (window.innerWidth <= 1199) {
    } else {
      gsap.set(".home_career_wrp .career_home_pic", {
        width: "100%",
        height: "100%",
        right: "0px",
      });

      // career Animation
      ScrollTrigger.create({
        trigger: ".home_career_wrp",
        start: "top 60%",
        end: "bottom bottom",
        onEnter: () => {
          const hoTl = gsap.timeline();

          // Animate .lineChild2 based on their order
          document
            .querySelectorAll(".home_career_wrp .lines .lineChild2")
            .forEach((element, index) => {
              hoTl.to(
                element,
                {
                  y: 0,
                  opacity: 1,
                  duration: 0.5,
                  ease: "circ.out",
                  delay: index * 0.1, // Delay based on position
                },
                0, // Keep them in sequence within the timeline
              );
            });

          // Animate .anims based on their order
          document
            .querySelectorAll(".home_career_wrp .anims")
            .forEach((element, index) => {
              hoTl.to(
                element,
                {
                  y: 0,
                  opacity: 1,
                  duration: 0.5,
                  ease: "circ.out",
                  delay: index * 0.1, // Delay based on position
                },
                0, // Keep them in sequence within the timeline
              );
            });
        },
      });

      if (window.innerWidth <= 767) {
        gsap.to(".home_career_wrp .career_home_pic", {
          scrollTrigger: {
            trigger: ".home_career_wrp",
            start: "top 60%",
            end: "bottom bottom",
            toggleActions: "play none reverse",
          },
          width: "100%",
          height: "50%",
          right: "0",
        });
      } else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
        gsap.to(".home_career_wrp .career_home_pic", {
          scrollTrigger: {
            trigger: ".home_career_wrp",
            start: "top 60%",
            end: "bottom bottom",
            toggleActions: "play none none none",
          },
          width: "55%",
          height: "90%",
          right: "20px",
        });
      } else {
        gsap.to(".home_career_wrp .career_home_pic", {
          scrollTrigger: {
            trigger: ".home_career_wrp",
            start: "top 60%",
            end: "bottom bottom",
            toggleActions: "play none none none",
          },
          width: "55%",
          height: "90%",
          right: "20px",
        });
      }
    }
  } */

  var sliderThumbnail = new Swiper(".slider-thumbnail", {
    slidesPerView: 3,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    autoHeight: true,
  });

  var Strategyslider = new Swiper(".Strategyslider", {
    autoHeight: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: sliderThumbnail,
    },
  });

  if ($(".targetSwiper").length > 0) {
    var targetSwiper = new Swiper(".targetSwiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      allowTouchMove: false,
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  }

  var vrangeSwiper3 = new Swiper(".vrangeSwiper3", {
    slidesPerView: "auto",
    spaceBetween: 20,
    watchSlidesProgress: true,
    centeredSlides: true,
    loop: true,
    grabCursor: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".versatile_range .swiper-button-next",
      prevEl: ".versatile_range .swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination-custom",
      clickable: true,
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: "auto",
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: "auto",
        spaceBetween: 20,
      },
    },
  });

  vrangeSwiper3.on("slideChange", function () {
    const slides = document.querySelectorAll(".vrangeSwiper3 .swiper-slide");
    slides.forEach(
      (slide) =>
        (slide.style.transition = "transform 0.3s ease, width 0.3s ease"),
    );

    const nameWrapper = document.querySelector(".centerContent h2");
    const summary = document.querySelector(".centerContent p");

    setTimeout(() => {
      const activeSlide = document.querySelector(
        ".vrangeSwiper3 .swiper-slide-active",
      );
      let dataName = activeSlide.dataset.name;
      let dataSummary = activeSlide.dataset.summary;

      // console.log(dataName, dataSummary);

      nameWrapper.innerHTML = dataName;
      summary.innerHTML = dataSummary;
    }, 500);
  });

  if ($(".showMoreBtn").length > 0) {
    const items = document.querySelectorAll(".report-list li");
    const showMoreBtn = document.getElementById("showMoreBtn");
    const initialVisible = 10; // show first 10
    const itemsPerClick = 5; // show 5 more each click
    let visibleCount = initialVisible;

    // Hide extra items initially
    items.forEach((item, index) => {
      if (index >= visibleCount) item.style.display = "none";
    });

    showMoreBtn.addEventListener("click", function (e) {
      e.preventDefault();

      // Show next 5 items
      const nextVisible = visibleCount + itemsPerClick;
      for (let i = visibleCount; i < nextVisible && i < items.length; i++) {
        items[i].style.display = "block";
      }

      visibleCount = nextVisible;

      // Hide button if all items are visible
      if (visibleCount >= items.length) {
        showMoreBtn.style.display = "none";
      }
    });

    // If total <= 10, hide button
    if (items.length <= initialVisible) {
      showMoreBtn.style.display = "none";
    }
  }

  if ($(".Milestones_cards").length > 0) {
    $("a.Milestones_cards").click(function () {
      $(this).find(".MilestonesHoverContent").addClass("active");
      $(this).find(".Business_Btn").addClass("active");
      if ($(".MilestonesHoverContent").hasClass("active")) {
        $(".Milestones_Details").css({ opacity: 0 });
      }
    });

    $("a.Milestones_cards").mouseleave(function () {
      $(".MilestonesHoverContent").removeClass("active");
      $(".Business_Btn").removeClass("active");
      $(".Milestones_Details").css({ opacity: 1 });
    });
  }

  if ($(".awardsSwiper").length > 0) {
    var awardsSwiper = new Swiper(".awardsSwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: ".award-next",
        prevEl: ".award-prev",
      },
      breakpoints: {
        300: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
    });
  }

  if ($(".Milestones_slider").length > 0) {
    var Milestones_slider = new Swiper(".Milestones_slider", {
      navigation: {
        nextEl: ".swiper-button-next.Milestones_slider-button-next",
        prevEl: ".swiper-button-prev.Milestones_slider-button-prev",
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1.3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2.3,
          spaceBetween: 40,
        },
      },
    });
  }

  /* anchore linking */
  if ($(".port-linking").length > 0) {
    let anchorLinksArr = $(".port-linking").find(".link-blurb");
    // Click handler (unchanged)
    anchorLinksArr.each(function () {
      $(this).on("click", function () {
        let currSectId = "#" + $(this).attr("attrSectLink");
        $("html, body").animate(
          {
            scrollTop: $(currSectId).offset().top - 60,
          },
          500,
        );
        anchorLinksArr.removeClass("active");
        $(this).addClass("active");
      });
    });

    var ancLinkSwiperslider = new Swiper(".link-hld", {
      navigation: {
        nextEl: ".link-button-next",
        prevEl: ".link-button-prev",
      },
      breakpoints: {
        300: {
          slidesPerView: 1.9,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 2.7,
          spaceBetween: 0,
        },
        880: {
          slidesPerView: 5,
          spaceBetween: 0,
        },
      },
    });
  }

  function stickyNavSetUp() {
    if ($(".sect-links").length > 0) {
      var stickySection = $(".sect-links"); // Tabs container
      var stickyOffset = stickySection.offset().top; // Offset for sticky behavior
      var headerHT = $("#header").innerHeight(); // Get header height
      var topHeadHT = $(".top_head").innerHeight();
      var winOffset = $(window).scrollTop();
      //$(window).scrollTop(0);
      // Set a placeholder height to prevent layout shift
      var placeholder = $('<div class="sticky-nav-pacer">')
        .height(headerHT)
        .hide();
      stickySection.before(placeholder);
      /*  placeholder.css({paddingTop:headerHT + 'px'}); */

      function checkWindowOffset() {
        var headerTop = parseInt($("#header").css("top"));
        var marginTopStr = $(".top_head").css("margin-top");
        var marginTopNum = parseInt(marginTopStr, 10) || 0;
        console.log(headerHT);
        if (winOffset + 20 >= stickyOffset) {
          if (!stickySection.hasClass("cr-nav-sticky")) {
            //stickySection.find("nav").addClass("container");
            stickySection.addClass("cr-nav-sticky");
            placeholder.show();
          }

          // Update sticky nav position based on header position
          if (headerTop === 0 && marginTopNum < 0) {
            if (window.innerWidth > 1024) {
              $(".cr-nav-sticky").css({ top: headerHT - 30 + "px" });
            } else {
              $(".cr-nav-sticky").css({ top: headerHT + 5 + "px" });
            }
          } else {
            $(".cr-nav-sticky").css({ top: headerHT + 5 + "px" });
          }
        } else {
          if (stickySection.hasClass("cr-nav-sticky")) {
            //stickySection.find("nav").removeClass("container");
            stickySection.removeClass("cr-nav-sticky");
            placeholder.hide();
            $(".sticky-page-nav").css({ top: "0px" });
          }
        }
      }
      checkWindowOffset();

      // Bind scroll event to update sticky state and active tab
      $(window).on("scroll", function () {
        winOffset = $(window).scrollTop();
        //stickyOffset = stickySection.offset().top;
        checkWindowOffset();
      });

      // Recalculate the sticky offset if the window is resized
      $(window).on("resize", function () {
        stickyOffset = stickySection.offset().top; // Recalculate the sticky offset
        checkWindowOffset(); // Recheck sticky state
      });
    }
  }

  $(window).on("resize", function () {
    stickyNavSetUp();
  });

  /* Map */
  let businessCatArr = $(".category-tabs").find("li");
  let pointersArr = $(".pointer-hld").find(".pointer");
  let titleHld = $(".cat-det-hld").find(".title");
  let unitsHld = $(".cat-det-hld").find(".units");
  let initialActiveDet = $(".active-pointers").find(".pointer-1");
  businessCatArr.each(function () {
    $(this).on("click", function () {
      let currCat = "#" + $(this).attr("id") + "-det";
      let currPointers = "#" + $(this).attr("id") + "-pointers";
      $(businessCatArr).removeClass("active-tab");
      $(".cat-det-panel").removeClass("active-det");
      $(".pointer-hld").removeClass("active-pointers");
      $(this).addClass("active-tab");
      $(currCat).addClass("active-det");
      $(currPointers).addClass("active-pointers");
      setTimeout(function () {
        let initialActiveDet = $(".active-pointers").find(".pointer-1");
        $(initialActiveDet).trigger("click");
      }, 100);
      $("html, body").animate(
        {
          scrollTop: $(".category-tabs").offset().top - 120,
        },
        500,
      );
    });
  });
  /* Pointer Click */
  pointersArr.each(function () {
    $(this).on("click", function () {
      let currTitle = $(this).data("title");
      let currUnits = $(this).data("units");
      pointersArr.removeClass("active");
      $(this).addClass("active");
      $(titleHld).text("");
      $(currUnits).text("");
      $(titleHld).text(currTitle);
      $(unitsHld).text(currUnits);
    });
  });

  
});

gsap.set(".anim", { y: 80, autoAlpha: 0 });

gsap.utils.toArray("section").forEach((section) => {
  ScrollTrigger.batch(section.querySelectorAll(".anim"), {
    start: "top 90%",
    onEnter: (batch) =>
      gsap.to(batch, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.2,
        duration: 0.8,
        overwrite: true,
      }),
  });
});
